import {
  Center as ChakraCenter,
  CenterProps,
  Square as ChakraSquare,
  SquareProps,
  Circle as ChakraCircle,
} from "@chakra-ui/react";

export default function Center(props: CenterProps): JSX.Element {
  return <ChakraCenter {...props} />;
}
export function Square(props: SquareProps): JSX.Element {
  return <ChakraSquare {...props} />;
}
export function Circle(props: SquareProps): JSX.Element {
  return <ChakraCircle {...props} />;
}
